import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { InsiderHighlightedBenefitBanner } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHighlightedBenefitBanner";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
export var InsiderProtectedEarlyAccessBanner = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(InsiderHighlightedBenefitBannerWithImage, {
        title: strictLocalize({
            id: "uV4uZd",
            defaultMessage: [
                {
                    type: 0,
                    value: "Unlock early access to new brands and the best deals"
                }
            ]
        }),
        description: strictLocalize({
            id: "XhIG0i",
            defaultMessage: [
                {
                    type: 0,
                    value: "With an Insider membership, you\u2019ll get exclusive, early access to shop our trade shows and the newest brands on Faire\u2014helping you snag the products you want, first."
                }
            ]
        })
    });
};
var InsiderHighlightedBenefitBannerWithImage = function(props) {
    var isSSR = useIsSSR();
    var _optimizeImageUrlFillRectangle, _optimizeImageUrlFillRectangle1;
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        mobile: /*#__PURE__*/ _jsx(InsiderHighlightedBenefitBanner, _object_spread({
            imgSrc: (_optimizeImageUrlFillRectangle = optimizeImageUrlFillRectangle({
                url: "https://cdn.faire.com/fastly/0e440e81ee72a3e7dc1358989ee9fa10274ae925c61164772b4067991b4ea82c.jpeg"
            }, isSSR, 375, 314)) !== null && _optimizeImageUrlFillRectangle !== void 0 ? _optimizeImageUrlFillRectangle : ""
        }, props)),
        tabletAndAbove: /*#__PURE__*/ _jsx(InsiderHighlightedBenefitBanner, _object_spread({
            imgSrc: (_optimizeImageUrlFillRectangle1 = optimizeImageUrlFillRectangle({
                url: "https://cdn.faire.com/fastly/6b6e83411398f0af61493a3400024d9c83c0bb78b0898efbc26619a4d2fc82df.jpeg"
            }, isSSR, 440, 500)) !== null && _optimizeImageUrlFillRectangle1 !== void 0 ? _optimizeImageUrlFillRectangle1 : ""
        }, props))
    });
};
